import React, { useEffect, useState } from 'react';
import Input from '@/components/input/input';
import Select from '@/components/input/select';
import { defaultSelectOptions } from '@/pages/statistics/reports/filters/filterParametrs';
import { FilterStore } from '@/store';
var WorkTimeFilter = function (_a) {
    var handleSetFilters = _a.handleSetFilters;
    var filterParams = FilterStore.useState(function (s) { return s.initialParams; });
    var totalOptionState = defaultSelectOptions.find(function (el) { return el.value === filterParams.total_work_time.split(' ')[0]; });
    var avgOptionState = defaultSelectOptions.find(function (el) { return el.value === filterParams.avg_work_time.split(' ')[0]; });
    var _b = useState({
        value: totalOptionState ? totalOptionState.value : '',
        name: totalOptionState ? totalOptionState.name : '',
    }), totalOption = _b[0], setTotalOption = _b[1];
    var _c = useState({
        value: avgOptionState ? avgOptionState.value : '',
        name: avgOptionState ? avgOptionState.name : '',
    }), avgOption = _c[0], setAvgOption = _c[1];
    var _d = useState(filterParams.total_work_time.split(' ')[1]), totalValue = _d[0], setTotalValue = _d[1];
    var _e = useState(filterParams.avg_work_time.split(' ')[1]), avgValue = _e[0], setAvgValue = _e[1];
    var handleSelect = function (_a) {
        var option = _a.option, name = _a.name;
        switch (name) {
            case 'total_work_time':
                if (option.value === '') {
                    setTotalOption({
                        value: '',
                        name: '',
                    });
                    setTotalValue(undefined);
                    handleSetFilters(name, 'all');
                    break;
                }
                setTotalOption(option);
                break;
            case 'avg_work_time':
                if (option.value === '') {
                    setAvgOption({
                        value: '',
                        name: '',
                    });
                    setAvgValue(undefined);
                    handleSetFilters(name, 'all');
                    break;
                }
                setAvgOption(option);
                break;
        }
    };
    var handleInput = function (e) {
        var _a = e.target, value = _a.value, name = _a.name;
        switch (name) {
            case 'total_work_time':
                setTotalValue(value);
                handleSetFilters(name, "".concat(totalOption.value, " ").concat(value));
                break;
            case 'avg_work_time':
                setAvgValue(value);
                handleSetFilters(name, "".concat(avgOption.value, " ").concat(value));
                break;
        }
    };
    useEffect(function () {
        if (totalValue) {
            handleSetFilters('total_work_time', "".concat(totalOption.value, " ").concat(totalValue));
        }
        if (avgValue) {
            handleSetFilters('avg_work_time', "".concat(avgOption.value, " ").concat(avgValue));
        }
    }, [totalOption, avgOption]);
    return (<div className="report_filters__box">
      <p className="report_filters__title">Длительность обслуживания</p>
      <div className="report_filters__input">
        <p className="report_filters__input-text">Всего</p>
        <Select width={264} name="total_work_time" placeholder={'Выбрать'} value={totalOption.name} onChange={handleSelect} options={defaultSelectOptions}/>
      </div>
      <div className="report_filters__input">
        <p className="report_filters__input-text">Минут</p>
        <Input type="number" name="total_work_time" width={264} onChange={handleInput} value={totalValue} disabled={totalOption.name === ''}/>
      </div>
      <div className="report_filters__input">
        <p className="report_filters__input-text">Средняя</p>
        <Select width={264} name="avg_work_time" placeholder={'Выбрать'} value={avgOption.name} onChange={handleSelect} options={defaultSelectOptions}/>
      </div>
      <div className="report_filters__input">
        <p className="report_filters__input-text">Минут</p>
        <Input type="number" name="avg_work_time" width={264} onChange={handleInput} value={avgValue} disabled={avgOption.name === ''}/>
      </div>
    </div>);
};
export default WorkTimeFilter;
